import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider } from 'styled-components';
import { I18nextProvider } from 'react-i18next';
import { NotificationProvider, Notifications } from '@ipc/ipc-components';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import i18n from '../../i18n/config';
import { muiTheme, styledTheme } from '../../theme/theme';
import { StrictPropsProvider } from '../../utils/StrictPropsProvider';
import { reactPlugin } from '../telemetry/appInsights';
import { ErrorBoundary } from '../telemetry/ErrorBoundary';
import { CssBaseline } from '@mui/material';
import { UserInformation } from './UserInformationProvider';

interface ProvidersProps {
  children: React.ReactNode;
}

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

const Providers = ({ children }: ProvidersProps) => {
  return (
    <ErrorBoundary>
      <AppInsightsContext.Provider value={reactPlugin}>
        <I18nextProvider i18n={i18n}>
          <QueryClientProvider client={queryClient}>
            <MuiThemeProvider theme={muiTheme}>
              <CssBaseline />
              <ThemeProvider theme={styledTheme}>
                <StrictPropsProvider>
                  <NotificationProvider>
                    <UserInformation>
                      <Notifications />
                      {children}
                    </UserInformation>
                  </NotificationProvider>
                </StrictPropsProvider>
              </ThemeProvider>
            </MuiThemeProvider>
          </QueryClientProvider>
        </I18nextProvider>
      </AppInsightsContext.Provider>
    </ErrorBoundary>
  );
};

export default Providers;
